import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { ImageComponent } from "../../global/imageComponent";
import { useDispatch } from "react-redux";
import { SELECT_SPORT } from "../../constants";
import { getGamedatas } from "../../actions/gameSettings";
import SportIcon from "../../common/SportIcon";

function Sidebar() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [activeSub, setActiveSub] = useState(null); // track active submenu
  const [gameDate, setGameData] = useState([]); // fetched sports data

  // fetch game data from backend
  const fetchGameData = async () => {
    try {
      const { status, message, result } = await getGamedatas(dispatch);
      console.log("fetchGameData ~ status, message, result:", status, message, result);
      if (status === true && Array.isArray(result)) {
        setGameData(result);
      }
    } catch (err) {
      console.log("err-fetch", err);
    }
  };

  // base sidebar items
  const baseSidebarData = [
    { id: 101, labelText: "Home", navLink: "/straight-bet/A-Z Betting", isActive: false, iconSrc: "homeIcon" },
    { id: 102, labelText: "Favorites", navLink: "/favorites", isActive: false, iconSrc: "favoritesIcon" },
    { id: 103, labelText: "Live", navLink: "/straight-bet/livemobius", isActive: false, iconSrc: "liveIcon" },
    { id: 104, labelText: "Call Bets", navLink: "/callbet", isActive: false, iconSrc: "bonusIcon" },
    { id: 105, labelText: "Active Bets", navLink: "/openbet", isActive: false, iconSrc: "betIcon" },
    {
      id: 106,
      labelText: "All Sports",
      navLink: null,
      isActive: true,
      isExpand: true,
    },
  ];

  const [sidebarList, setSidebarList] = useState([...baseSidebarData]);

  // Update active states based on URL
  useEffect(() => {
    const currentPath = location.pathname;

    setSidebarList((prev) =>
      prev.map((item) => {
        let active = false;
        if (item.navLink) {
          active = currentPath === item.navLink || currentPath === `${item.navLink}/`;
        } else if (item.id === 106) {
          // All Sports is active if we are in /straight-bet but NOT Home or Live
          active =
            currentPath.startsWith("/straight-bet") &&
            currentPath !== "/straight-bet/A-Z Betting" &&
            currentPath !== "/straight-bet/livemobius";
        }
        return { ...item, isActive: active };
      })
    );

    if (currentPath.startsWith("/straight-bet")) {
      const sportFromURL = decodeURIComponent(location.pathname.split("/")[2] || "");
      setActiveSub(location.state?.selectedSport || sportFromURL);
    } else {
      setActiveSub(null);
    }
  }, [location]);

  // Fetch game data on mount
  useEffect(() => {
    fetchGameData();
  }, []);

  // toggle sidebar parent
  const sidebarClickHandle = (item) => {
    if (item.navLink) {
      if (item.id === 103) {
        dispatch({ type: SELECT_SPORT, data: "livemobius" });
        history.push({
          pathname: "/straight-bet/livemobius",
          state: { selectedSport: "livemobius" },
        });
        return;
      }
      history.push(item.navLink);
    } else {
      setSidebarList((prev) =>
        prev.map((it) =>
          it.id === item.id ? { ...it, isExpand: !it.isExpand } : { ...it, isExpand: false }
        )
      );
    }
  };

  // click on submenu item
  const subMenuClickHandle = (subItem) => {
    if (subItem.navLink) {
      dispatch({ type: SELECT_SPORT, data: subItem.labelText });
      history.push({
        pathname: `/straight-bet/${encodeURIComponent(subItem.labelText)}`,
        state: { selectedSport: subItem.labelText },
      });
    }
  };

  // dynamically add subMenu to All Sports
  // Inside your Sidebar component, replace the dynamicSidebarList creation with this:

  const dynamicSidebarList = sidebarList.map((item) => {
    if (item.id === 106) {
      // Default submenu item
      const defaultSub = {
        subId: 1,
        labelText: "A-Z Betting",
        navLink: "/straight-bet",
        isActive: false,
        iconSrc: "aTozIcon",
      };

      // Map dynamic fetched sports
      const dynamicSubs = gameDate.map((sport, index) => {
        const label = sport._id || sport.name || `Sport ${index + 2}`; // +2 because 1 is default
        return {
          subId: index + 2, // start after default
          labelText: label,
          navLink: "/straight-bet",
          iconUrl: sport.iconUrl || null,
        };
      });

      return {
        ...item,
        subMenu: [defaultSub, ...dynamicSubs], // merge default + dynamic
      };
    }
    return item;
  });


  return (
    <div className="mg-sidebar-component">
      <ul>
        {dynamicSidebarList.map((item) => (
          <li key={item.id}>
            <div
              className={`sidebarListHeader ${item?.isActive ? "isActive" : ""}`}
              onClick={() => sidebarClickHandle(item)}
            >
              <div className="d-flex align-items-center gap-2">
                <ImageComponent staticImgSrc={item?.iconSrc} />
                <h3 className="fs15">{item?.labelText}</h3>
              </div>
              {item.subMenu && (
                <button className="arrowIcon">
                  <IoIosArrowForward />
                </button>
              )}
            </div>

            {item?.isExpand && item?.subMenu && (
              <div className="sidebarListBody">
                <ul>
                  {item?.subMenu.map((subItem) => (
                    <li
                      key={subItem?.subId}
                      className={`sidebarListHeader ${activeSub === subItem?.labelText ? "isActive" : ""}`}
                      onClick={() => subMenuClickHandle(subItem)}
                    >
                      <div className="d-flex align-items-center gap-2">
                        {subItem?.iconSrc ? (
                          <ImageComponent staticImgSrc={subItem.iconSrc} />
                        ) : (
                          <SportIcon
                            sportName={subItem?.labelText}
                            iconUrl={subItem?.iconUrl}
                            size={22}
                          />
                        )}
                        <h3 className="fs14">{subItem?.labelText}</h3>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
